module.exports = __webpack_public_path__ + "img/cover-2.5fd549fe.png";